//@ts-nocheck

import React, { CSSProperties, ReactElement, ReactNode } from "react";
import { Col as GridColumn } from "react-grid-system";
import { Pull, Push, Offsets, ScreenClassMap } from "./Container";

export interface ColumnProps extends ScreenClassMap<number> {
  width?: "auto" | number | string;
  offset?: Offsets;
  push?: Push;
  pull?: Pull;
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
}

const Column = (props: ColumnProps): ReactElement => {
  return <GridColumn {...props} />;
};

export default Column;
